import posthog, { CapturedNetworkRequest } from "posthog-js";

/**
 * Matches any JSON string key containing "password", case-insensitively.
 * Covers Cognito's wire-format keys (PASSWORD, NEW_PASSWORD nested in
 * AuthParameters/ChallengeResponses; Password, PreviousPassword,
 * ProposedPassword, TemporaryPassword from SignUp/ChangePassword/
 * ConfirmForgotPassword/AdminCreateUser) as well as this app's own
 * oldPassword/newPassword/confirmPassword/currentPassword field names.
 */
const SENSITIVE_BODY_KEY_PATTERN = /("[a-z_]*password[a-z_]*":\s*")[^"]*"/gi;

const redactSensitiveBodyKeys = (body?: string | null) =>
  body?.replace(SENSITIVE_BODY_KEY_PATTERN, '$1redacted-password"');

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_KEY!, {
  api_host: "/rmh-relay",
  ui_host: "https://us.posthog.com",
  defaults: "2026-01-30",
  capture_pageleave: true,
  enable_recording_console_log: true,
  session_recording: {
    strictMinimumDuration: true,
    maskCapturedNetworkRequestFn: (request: CapturedNetworkRequest) => {
      // Mark all password content in request and response body as redacted. Since we want to unmask as much as possible for
      // debugging purposes, we will be using a blacklisting approach.
      request.requestBody = redactSensitiveBodyKeys(request.requestBody);
      request.responseBody = redactSensitiveBodyKeys(request.responseBody);

      return request;
    },
    maskInputFn: (text, element) => {
      // Mask all input with type password or has id or name that contains "password"
      if (
        element?.attributes["type"]?.value === "password" ||
        element?.attributes["id"]?.value?.toLowerCase().includes("password") ||
        element?.attributes["name"]?.value?.toLowerCase().includes("password")
      ) {
        return "*".repeat(text.length);
      }
      return text;
    },
  },
});
